import React, {useState} from 'react';
import * as UserErrorCodes from '../../ErrorCodes/UserErrors';
//import * as LogFunctions from './../Helpers/LogFunctions';
import {
    ActivityIndicator,
    CCText,
    Image, TouchableWithoutFeedback,
    View
} from '../../custom-packages/react-native-components-in-react/react-native-components-in-react';
import ChocoForm from '../../custom-packages/react-chocoforms/legacy/ChocoForm';
import TAuth from './Translations/TAuth';
import logo from './../../assets/logo.png';

import * as AuthActions from './../../store/actions/authActions';
import {useDispatch} from 'react-redux';

import {BorderlessButton, ThemeButton} from '../../custom-packages/react-button-package/ButtonPackage';
import AppConfig from '../../AppConfig';
import Styles from '../../Styles';

import { GoogleOAuthProvider} from '@react-oauth/google';
import {useNavigate, useParams} from 'react-router-dom';
import {
    AppleAuthHandler,
    AppleSignUpHandler,
    AuthSuccessHandler,
    GetAuthObject,
    GoogleAuthHandler
} from "../../authentication/AuthFunctions";
import GoogleSignIn from "../../custom-packages/sign-in-button/GoogleSignIn";
import {RegisterEvent} from "../../AnalyticsFunctions";
import AppleSignInWrapper from "../../custom-packages/sign-in-button/AppleSignInWrapper";
import TOSModal from "../../custom-packages/tos-modal/TOSModal";
import CaretDownIcon from "../../assets/custom-icons/CaretDownIcon";
import CaretRightIcon from "../../assets/custom-icons/CaretRightIcon";
import {Collapse} from "react-collapse";
import {TSubscriptionItem} from "../../components/subscriptions/SubscriptionItem";


const SignUpScreen = (props) => {
    const params = useParams()
    const type = params.type;

    const navigate = useNavigate();
    const dispatch = useDispatch()

    const [loading, setLoading] = useState(false);
    const [showOtherLoginOptions, setShowOtherLoginOptions] = useState(false)

    const [signUpForm, setSignUpForm] = useState({
        controls: {
            email: {
                elementType: 'input',
                elementConfig: {
                    placeholder: TAuth[AppConfig.lang].EMAIL,
                    autoCapitalize: 'none'
                },
                label: TAuth[AppConfig.lang].EMAIL,
                value: '',
                errorMessage: '',
                validation: {
                    required: true,
                    isEmail: true
                },
                valid: false,
                touched: false,
            },
            name: {
                elementType: 'input',
                elementConfig: {
                    placeholder: TAuth[AppConfig.lang].NAME,
                },
                label: TAuth[AppConfig.lang].NAME,
                value: '',
                errorMessage: '',
                validation: {
                    required: true
                },
                valid: false,
                touched: false,
            },
            password: {
                elementType: 'input',
                name: 'password',
                elementConfig: {
                    //secureTextEntry: true,
                    placeholder: TAuth[AppConfig.lang].YOUR_PASSWORD,
                    autoCapitalize: 'none'
                },
                label: TAuth[AppConfig.lang].YOUR_PASSWORD,
                value: '',
                errorMessage: '',
                validation: {
                    isPassword: true,
                    required: true,
                    minLength: 6
                },
                valid: false,
                touched: false,
            },
            termsOfServiceAccepted: {
                elementType: 'tos',
                name: 'termsOfServiceAccepted',
                errorMessage: '',
                value: false,
                validation: {
                    tos: true,
                },
                valid: false,
                touched: false,
            }
        },
    })

    /*
     * FUNCTIONS
     */

    const authSuccessHandler = (json) => {
        const storedAuth = GetAuthObject(json);

        dispatch(AuthActions.saveAuth(storedAuth))

        navigate('/admin/setup/subscription' + window.location.search, { replace: true });
    }


    const signUpHandler = async () => {
        const deviceID = localStorage.getItem('deviceID');

        setLoading(true)

        let formData = {};

        for (let key in signUpForm.controls) {
            formData[key] = signUpForm.controls[key].value;
        }

        formData['type'] = type;

        const response = await fetch(AppConfig.URL + "/Account/Signup", {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'DeviceID': deviceID
            },
            body: JSON.stringify(formData)
        });

        var json = await response.json();

        if (json.success) {
            authSuccessHandler(json)
        } else {
            const form = { ...signUpForm };

            if (json.errorCode === UserErrorCodes.USERNAME_ALREADY_EXISTS) {
                form.generalError = {
                    text: TAuth[AppConfig.lang].USERNAME_EXISTS,
                    show: true
                }
            } else if (json.errorCode === UserErrorCodes.EMAIL_ALREADY_EXISTS) {
                form.generalError = {
                    text: TAuth[AppConfig.lang].EMAIL_EXISTS,
                    show: true
                }
            } else if (json.errorCode === UserErrorCodes.TERMS_OF_SERVICE_REQUIRED) {
                form.generalError = {
                    text: TAuth[AppConfig.lang].TERMS_OF_SERVICE_REQUIRED,
                    show: true
                }
            }

            setSignUpForm(form)
        }

        setLoading(false)
    }

    return (
        <View className="row">
            <View className="col-md-3 col-lg-4">
            </View>
            <View className="col-md-6 col-lg-4">
                <View
                    className={'card'}
                >
                    <View className="card-body" style={{ justifyContent: 'center', alignItems: 'center' }}>
                        <h2 style={{ textAlign: 'center', marginBottom: 20 }}>
                            {TAuth[AppConfig.lang].LOGIN_TITLE}
                        </h2>
                        {loading ?
                            <View style={{ justifyContent: 'center', alignItems: 'center', padding: 60 }}>
                                <ActivityIndicator />
                            </View>
                            :
                            <View>
                                <Collapse
                                    isOpened={!showOtherLoginOptions}
                                >
                                    <View>
                                        <View style={{ alignSelf: 'center', marginBottom: 30 }}>
                                            <GoogleOAuthProvider
                                                clientId="311231473058-g5ra5hhgep2qai2pk3t6ej8015lcedid.apps.googleusercontent.com"
                                            >
                                                <GoogleSignIn
                                                    onClick={async (credentialResponse) => {
                                                        RegisterEvent({
                                                            source: window.location.href,
                                                            sequenceID: AppConfig.ANALYTICS_SEQUENCE_SIGNUP,
                                                            action: 'CLICK_GOOGLE_SIGN_IN_BUTTON'
                                                        })

                                                        try {
                                                            setLoading(true);

                                                            const response = await GoogleAuthHandler(credentialResponse)

                                                            if(response.msg) {
                                                                const form = { ...signUpForm };

                                                                form.generalError = {
                                                                    text: response.msg,
                                                                    show: true
                                                                }

                                                                setSignUpForm(form)
                                                            }

                                                            if(response.auth)
                                                                dispatch(AuthActions.saveAuth(response.auth))

                                                            if(response.navigateTo)
                                                                navigate(response.navigateTo, {replace: true});
                                                        } catch (e) {
                                                            console.log(e);
                                                        } finally {
                                                            setLoading(false);
                                                        }
                                                    }}
                                                />
                                            </GoogleOAuthProvider>
                                            <div style={{ height: 10 }}></div>
                                            <AppleSignInWrapper
                                                redirectUri={'https://tastee.app'}
                                                onClick={async (appleResponse) => {
                                                    RegisterEvent({
                                                        source: window.location.href,
                                                        sequenceID: AppConfig.ANALYTICS_SEQUENCE_SIGNUP,
                                                        action: 'CLICK_APPLE_SIGN_IN_BUTTON'
                                                    })

                                                    try {
                                                        setLoading(true);

                                                        const response = await AppleAuthHandler(appleResponse)

                                                        if(response.msg) {
                                                            const form = { ...signUpForm };

                                                            form.generalError = {
                                                                text: response.msg,
                                                                show: true
                                                            }

                                                            setSignUpForm(form)
                                                        }

                                                        if(response.auth)
                                                            dispatch(AuthActions.saveAuth(response.auth))

                                                        if(response.navigateTo)
                                                            navigate(response.navigateTo, {replace: true});
                                                    } catch (e) {
                                                        console.log(e);
                                                    } finally {
                                                        setLoading(false);
                                                    }
                                                }}
                                            />
                                            <div style={{ height: 10 }}></div>
                                            <TouchableWithoutFeedback
                                                onPress={() => {
                                                    RegisterEvent({
                                                        source: window.location.href,
                                                        sequenceID: AppConfig.ANALYTICS_SEQUENCE_SIGNUP,
                                                        action: 'CLICK_MAIL_AND_PASSWORD_BUTTON'
                                                    })

                                                    setShowOtherLoginOptions(!showOtherLoginOptions)
                                                }}
                                                style={{ padding: 10, backgroundColor: 'white', border: '1px solid #CCCCCC', fontSize: 18, borderRadius: 4, fontWeight: 'bold', textAlign: 'center' }}
                                            >
                                                {TAuth[AppConfig.lang].SIGN_IN_EMAIL}
                                            </TouchableWithoutFeedback>
                                        </View>
                                    </View>
                                </Collapse>
                                <Collapse
                                    isOpened={showOtherLoginOptions}
                                >
                                    <View>
                                        <ChocoForm
                                            lang={AppConfig.lang}
                                            form={signUpForm}
                                            onFormChange={(updatedForm) => {
                                                setSignUpForm(updatedForm)
                                            }}
                                        />
                                        <View style={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
                                            <BorderlessButton
                                                text={TAuth[AppConfig.lang].CANCEL}
                                                onPress={() => {
                                                    setShowOtherLoginOptions(!showOtherLoginOptions)
                                                }}
                                            />
                                            <View style={{ width: 7 }}></View>
                                            <ThemeButton
                                                text={TAuth[AppConfig.lang].LOGIN}
                                                onPress={signUpHandler}
                                                disabled={!signUpForm.isValidForm}
                                            />
                                        </View>
                                    </View>
                                    <View style={{ marginBottom: 15, marginTop: 5 }}>
                                        <View style={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
                                            <BorderlessButton
                                                text={TAuth[AppConfig.lang].HAVE_ACCOUNT}
                                                textStyle={{ fontWeight: 'bold', ...Styles.themeColor }}
                                                to="/auth?type=BUSINESS"
                                                onPress={() => { }}
                                            />
                                        </View>
                                    </View>
                                </Collapse>
                                <div
                                    dangerouslySetInnerHTML={{__html: TSubscriptionItem[AppConfig.lang].TERMS_OF_SERVICE}}
                                    style={{textAlign: 'center', fontSize: 14}}
                                >
                                </div>
                            </View>
                        }
                    </View>
                </View>
            </View>
            <View className="col-md-3 col-lg-4">
            </View>
        </View>
    );
};

export default SignUpScreen;